import {
  DayOptions,
  DurationOptions,
  TimezoneOptions,
  WeekOptions
} from 'common/types/frequencySelector/frequencyOptions';
import { I18n } from 'common/visualizations';

const intervalOptionsScope = 'shared.components.frequency_selector.interval.type';
const dayOptionsScope = 'shared.components.frequency_selector.interval.day';
const weekOptionsScope = 'shared.components.frequency_selector.interval.week';
const timezoneOptionsScope = 'shared.components.frequency_selector.time.timezone';

export const intervalOptions: DurationOptions[] = [
  { value: 'day', label: I18n.t('day', { scope: intervalOptionsScope }) },
  { value: 'week', label: I18n.t('week', { scope: intervalOptionsScope }) },
  { value: 'month', label: I18n.t('month', { scope: intervalOptionsScope }) }
];

export const dayOptions: DayOptions[] = [
  { value: 'mon', label: I18n.t('mon', { scope: dayOptionsScope }) },
  { value: 'tue', label: I18n.t('tue', { scope: dayOptionsScope }) },
  { value: 'wed', label: I18n.t('wed', { scope: dayOptionsScope }) },
  { value: 'thu', label: I18n.t('thu', { scope: dayOptionsScope }) },
  { value: 'fri', label: I18n.t('fri', { scope: dayOptionsScope }) },
  { value: 'sat', label: I18n.t('sat', { scope: dayOptionsScope }) },
  { value: 'sun', label: I18n.t('sun', { scope: dayOptionsScope }) }
];

export const weekOptions: WeekOptions[] = [
  { value: 'first', label: I18n.t('first', { scope: weekOptionsScope }) },
  { value: 'second', label: I18n.t('second', { scope: weekOptionsScope }) },
  { value: 'third', label: I18n.t('third', { scope: weekOptionsScope }) },
  { value: 'fourth', label: I18n.t('fourth', { scope: weekOptionsScope }) },
  { value: 'last', label: I18n.t('last', { scope: weekOptionsScope }) }
];

export const timezoneOptions: TimezoneOptions[] = [
  { value: 'pst', label: I18n.t('pst', { scope: timezoneOptionsScope }) },
  { value: 'mst', label: I18n.t('mst', { scope: timezoneOptionsScope }) },
  { value: 'cst', label: I18n.t('cst', { scope: timezoneOptionsScope }) },
  { value: 'est', label: I18n.t('est', { scope: timezoneOptionsScope }) },
  { value: 'utc', label: I18n.t('utc', { scope: timezoneOptionsScope }) }
];
